import { UzCombobox } from '@utazzo/ui';

import { usePickerOptions } from './usePickerOptions';

import * as countriesApi from '@/features/countries/countries.api';

interface CountryPickerProps {
  label?: string;
  value: string | null;
  onValueChange: (value: string | null) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
}

export const CountryPicker = ({
  label = 'Country',
  value,
  onValueChange,
  required,
  disabled,
  error,
  hint,
}: CountryPickerProps): React.JSX.Element => {
  const { options, loading, setSearch } = usePickerOptions(
    {
      cacheKey: 'picker.countries',
      fetch: async (search) => {
        const res = await countriesApi.listCountries({
          page: 1,
          pageSize: 30,
          sortDir: 'asc',
          ...(search ? { search } : {}),
        });
        return res.data;
      },
      fetchOne: async (id) => {
        try {
          return await countriesApi.getCountry(id);
        } catch {
          return null;
        }
      },
      toOption: (c) => ({
        value: c.id,
        label: c.name,
        description: c.isoCode ?? undefined,
      }),
    },
    value,
  );

  return (
    <UzCombobox
      label={label}
      placeholder="Select a country"
      searchPlaceholder="Search countries..."
      value={value ?? ''}
      onValueChange={(v) => onValueChange(v || null)}
      onSearchChange={setSearch}
      options={options}
      loading={loading}
      required={required}
      disabled={disabled}
      error={error}
      hint={hint}
    />
  );
};
